import {
  HttpErrorResponse, HttpEvent,
  HttpHandler,


  HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authenticationService: AuthenticationService) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        retry(0),
        catchError((error: HttpErrorResponse) => {

          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            errorMessage = `Error: ${error.message}`;
          } else {

            errorMessage = error.error.message;
            switch (error.status) {
              case 400:
                errorMessage = 'ERROR: Authentication failed. Please try again.';
                //  errorMessage='The UserId or Password that you have entered is incorrect.';
                break;
              case 404:
                errorMessage = 'ERROR(404) : URL not found.';
                break;
              case 401:
               this.authenticationService.logout();
               location.reload(true);
    
                break;
              case 403:
                errorMessage = 'ERROR: You do not have permission to access server.';
                break;
              case 0:
                errorMessage = 'ERROR: The service is temporarily unable to service your request . Please try again later.';
                break;
            }


            if (error.error === 'invalid_token') {
              this.authenticationService.logout();
              location.reload(true);
            }

          }
          return throwError(errorMessage);
        })
      )

  }
}

